// src/pages/DirectExpenseBalance/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { ArrowLeftOutlined, DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import DirectExpenseBalanceFilters from "./components/DirectExpenseBalanceFilters";
import DirectExpenseBalanceTable from "./components/DirectExpenseBalanceTable";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import { exportDirectExpenseBalanceCsv } from "./components/exportDirectExpenseBalanceCsv";

const { Title } = Typography;

const DirectExpenseBalance = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
   const { filters, list, balanceTotal } = useSelector(
    (state) => state.directExpenseBalance
  );
  const navigate = useNavigate();

  const handleNavigateToReports = () => {
    navigate("/reports");
  };

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Direct Expense Balance Report",
    removeAfterPrint: true,
  });
 const handleDownloadCsv = () => {
    exportDirectExpenseBalanceCsv({
      list,
      balanceTotal,
      title:    "Direct Expense Balance Report",
      filename: "direct_expense_balance",
    });
  };

  const hasData = list.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
          <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              />
          <Title level={4} style={{ margin: 0 }} className="reportBigTitle">Direct Expense Balance Report</Title>
          </div>
          }
          extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <DirectExpenseBalanceFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <DirectExpenseBalanceTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Direct Expense Balance Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <DirectExpenseBalanceTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default DirectExpenseBalance;
